'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:WorklistCtrl
* @description
* Worklist controller.
*
*/

angular.module('tcApp')
.value('worklistData', null)
.controller('WorklistCtrl', function($scope, $log, $location, $timeout, $window,
									worklistData, GlobalService, WorkflowService, SystemRouter, ElementStateService,
									RouteParamsCache, BreadcrumbService) {
	
	var initialiseCtrl = function(worklistData) {
		if (worklistData != null) {
			$scope.data = worklistData.data;
		}
		if (angular.isUndefined($scope.data)) $scope.data = {};
		if (!angular.isObject($scope.options)) $scope.options = {};
		$scope.globalStrings = GlobalService.getGlobalStrings();
		$scope.viewModel = {
			worklistHtmlName: 'tc_Worklist',
			isLoading: false
		};
		
		if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
		if ($scope.data.counters) GlobalService.updateCounters($scope.data.counters);
		
		// check if any worklist item component needs to be reloaded
		var checkCachedNested = ($scope.data._isCached === true);
		if (checkCachedNested && angular.isDefined($scope.data.items)) {
			angular.forEach($scope.data.items, function(item) {
				if ((angular.isDefined(item.componentData)) && (item.componentData.componentAlwaysReload)) {
					// require a timeout as reloadComponent still thinks $scope is the page before the navBack
					$timeout(function reloadWorklistItemComponent() {
						GlobalService.reloadComponent(item.componentData.componentParamPrefix);
					});
				}
			});
		}
	};
	
	$scope.selectWorklistItem = function(componentName, componentParams, linkUrl, worklistItemIndex) {
		if (angular.isDefined(linkUrl) && (linkUrl !== '')) {
			var newLocation = WorkflowService.getNextLevelUrl(linkUrl);
			$location.url(newLocation);
		} else {
			loadWorklistItem(componentName, componentParams, worklistItemIndex);
		}
	};
	
	// Loads a component via the worklist item menu
	var loadWorklistItem = function(componentName, componentParams, worklistItemIndex) {
		$scope.viewModel.isLoading = true;
		componentParams = (componentParams || {});
		if (!angular.isObject(componentParams)) {
			componentParams = GlobalService.urlToObject(componentParams);
		}
		componentParams['TLOADNESTEDCOMPONENT'] = 1;
		componentParams['TWORKLISTITEM'] = worklistItemIndex;
		
		resetCachedParams();
		unloadWorklistItems();
		
		SystemRouter.fetchComponentData(componentName, componentParams)
		.then(function(response) {
			$scope.viewModel.isLoading = false;
			if (angular.isDefined(response.data.componentParamPrefix)) {
				// Remove element state for nested component reloads
				ElementStateService.removeKeysForComponent(response.data.componentParamPrefix);
			}
			$scope.data.items[worklistItemIndex - 1].componentName = componentName;
			$scope.data.items[worklistItemIndex - 1].componentData = response.data;
			if (angular.isDefined(componentParams['CONTEXT'])) {
				$scope.data.items[worklistItemIndex - 1].context = componentParams['CONTEXT'];
			}
			var breadcrumbData = BreadcrumbService.data;
			var current = breadcrumbData.breadcrumbs[breadcrumbData.breadcrumbs.length - 1];
			var worklistCaption = $scope.data.menuComponentData.translations.WorklistCaption;
			if (angular.isDefined(worklistCaption)) {
				current.caption = (worklistCaption + ' - ' + response.data.componentHeaderCaption);
			} else {
				current.caption = response.data.componentHeaderCaption;
			}
			$timeout(function focusToWorklistItem() {
				var formElement = $window.document.getElementById(response.data.componentParamPrefix + '-ngForm');
				if (formElement) GlobalService.focusFirstInElement(formElement);
			}, 100);
		});
	};
	
	var resetCachedParams = function() {
		// remove preserved search (and other user actioned list params like page/sort)
		var cachedRouteParams = RouteParamsCache.get($location.url());
		if ((cachedRouteParams) && (angular.isDefined(cachedRouteParams.TUNIQUELISTPARAMS))) {
			angular.forEach(cachedRouteParams.TUNIQUELISTPARAMS, function(uniqueListParam) {
				angular.forEach(uniqueListParam, function(param, paramKey) {
					delete cachedRouteParams[paramKey];
				});
			});
			delete cachedRouteParams.TUNIQUELISTPARAMS;
			RouteParamsCache.put($location.url(), cachedRouteParams);
		}
	};
	
	// Remove all existing component data in worklist items. This will force reload of the component directive
	var unloadWorklistItems = function() {
		angular.forEach($scope.data.items, function unloadWorklistItem(worklistItem) {
			if (angular.isDefined(worklistItem.componentData)) {
				worklistItem.componentData = undefined;
				worklistItem.componentName = undefined;
				worklistItem.context = undefined;
				worklistItem.linkOnly = false;
			}
		});
		// Reset the primary component on switching worklist items
		GlobalService.setPrimaryComponent({
			routePath: $location.path()
		});
	};

	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});
	
	$scope.$on('Global:callFunction', function(event, componentHtmlName, 
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'Worklist') return;

		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
		}
	});

	initialiseCtrl(worklistData);

});
